import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../lib/utils.js";

export function Card({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      className={cn(
        "rounded-2xl border border-simuflex-line bg-white shadow-[0_8px_24px_-6px_rgba(26,59,105,0.05)] hover:shadow-[0_12px_32px_-6px_rgba(26,59,105,0.08)] hover:-translate-y-0.5 transition-all duration-300 transform-gpu",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <div
      className={cn(
        "border-b border-simuflex-line px-6 py-4 flex items-center justify-between bg-simuflex-mist/20 rounded-t-2xl",
        className,
      )}
    >
      {children}
    </div>
  );
}

export function CardTitle({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <h3 className={cn("text-sm font-bold text-simuflex-navy tracking-wide uppercase", className)}>
      {children}
    </h3>
  );
}

export function CardBody({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): JSX.Element {
  return <div className={cn("px-6 py-5", className)}>{children}</div>;
}
